import LinearGradient from './LinearGradient';
import type { LinearGradientProps } from './types';

export default LinearGradient;
export { LinearGradient, LinearGradientProps };
